import LightModeIcon from "@mui/icons-material/LightMode";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import { Box, IconButton, useTheme } from "@mui/material";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toggleMode } from "../../../redux/actions/actions";

export default function DarkLightMode() {
  const dispatch = useDispatch();
  const lightMode = useSelector((state) => state.mode.lightMode);

  const theme = useTheme();

  useEffect(() => {
    localStorage.setItem("lightMode", lightMode);
  }, [lightMode]);
  return (
    <IconButton
      sx={{
        width: 48,
        height: 48,
        padding: ".5rem",
      }}
      onClick={() => dispatch(toggleMode())}
    // sx={{
    //   cursor: "pointer",
    //   display: "flex",
    //   alignItems: "center",
    //   // width: { xs: "56px", md: "56px" },
    //   width: { xs: "36px", md: "36px" },
    //   height: { xs: "36px", md: "36px" },
    //   padding: "3px",
    //   borderRadius: "2rem",
    //   // marginLeft: "auto",
    //   // marginRight: { xs: 0, md: "auto" },

    //   // boxShadow: `0 0px 3px ${lightMode ? "#999" : "#ffffff"}`,
    //   // border: lightMode ? "1px solid #292929" : "1px solid #9ca3af",
    //   // background: lightMode
    //   //   ? "radial-gradient(#FFFFFF, #fff, #fff, #efefef, #fff)"
    //   //   : "radial-gradient(#000, #f08049, #000, #000, red)",
    //   boxShadow:
    //     "0 0 2px 0 rgba(145 158 171 / 0.2),0 12px 24px -4px rgba(145 158 171 / 0.12)",
    //   // boxShadow:
    //   //   "1px 1px 1px 0 rgba(0, 0, 0, 0.2),3px 3px 3px 0 rgba(0, 0, 0, 0.19)",
    // }}
    >
      <Box
        sx={{
          // boxShadow:
          //   "1px 1px 1px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: { xs: "24px", md: "24px" },
          height: { xs: "24px", md: "24px" },
          backgroundColor: lightMode ? "transparent" : "transparent",
          borderRadius: "100%",
          position: "relative",
          // left: !lightMode ? { xs: "27px", md: "24px" } : "0",
          transition: "left .4s",
          mx: "auto",
        }}
      >
        {!lightMode ? (
          <DarkModeIcon
            sx={{ fontSize: { xs: "16px", md: "24px" }, color: "#ffffff" }}
          />
        ) : (
          <LightModeIcon
            sx={{
              fontSize: { xs: "16px", md: "24px" },
              color: lightMode ? theme.palette.primary.main : "#9ca3af",
            }}
          />
        )}
      </Box>
      {/* <Box
        onClick={() => setLightMode(false)}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "32px",
          height: "32px",
          backgroundColor: "#707070",
          borderRadius: "100%",
        }}
      >
        <DarkModeIcon sx={{ color: "#000000" }} />
      </Box> */}
    </IconButton>
  );
}
